<div>
  <div class="title margin-top-sm">
    <span class="drag-handle"></span>
  </div>
  <ng-container>
    <div class="title margin-top-lg">
      {{ data.title }}
    </div>
    <div class="options margin-top-md">
      @for (option of data.options; track option) {
        <div
          class="margin-bottom-md"
          data-test="upload-options"
          [attr.data-testid]="'upload-' + (option.displayName.toLowerCase().includes('take picture') ? 'singleFile' : 'multiPages')"
          (click)="changeChosenValue(option.name)"
          >
          <span [ngClass]="chosenValue !== option.name ? 'text-fade' : ''"  fxLayoutAlign=" center"
            >@if (option.icon) {
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            }&nbsp;&nbsp;{{ option.displayName }}</span
            >
            @if (chosenValue === option.name) {
              <mat-icon svgIcon="tick-blue"></mat-icon>
            }
          </div>
        }
      </div>
    </ng-container>
  </div>
